export interface Client {
  id: number,
  name: string,
  email: string,
  responsibleUserId: string,
  responsibleTeamId: string,
  responsibleUserIdSecondary: string,
  responsibleTeamIdSecondary: string,
  externalResponsibleUserId: string,
  legalFormId: string,
  specialCode: string,
  dueInvoiceNotification: string
}

export interface IClientsState {
  clients: any[];
}

export const initialClientsState: IClientsState = {
  clients: [],
};
